import React from 'react'

class InstrumentCatalogDiv extends React.Component {
    state = {
        id: this.props.id || 0,
        fatherID: this.props.fatherID || 0,
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        const { id, fatherID } = this.state
        Tyan.doPostEvent('GetInstrumentCatalog', {
            data: { id, fatherID },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { id, fatherID } = this.state
        Tyan.doPostEvent('SaveInstrumentCatalog', {
            data: { fatherID, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onRefresh } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent('DelInstrumentCatalog', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('保存成功')
                        onClose && onClose()
                        onRefresh && onRefresh()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged() && !Tyan.checkForm.checkLimited(this)
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }

    handlerChange = (v) => {
        Tyan.doPostEvent('GetRelationInfo', {
            data: { type: '人员姓名', objRelationInfo: { '部门属性': Tyan.utility.getFormValue(this, '基本信息', '部门属性'), '人员姓名': v } },
            onEnd: ({ errorMessage, optionsParas }) => {
                if (optionsParas) {
                    this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
                }
            }
        })
    }

    fieldset基本信息 = () => {
        const 父级名称 = Tyan.utility.getFormValue(this, '基本信息', '父级名称')
        return [
            { _text: '父级名称', disabled: true, cdt: () => 父级名称 },
            { _text: '分类名称', required: true },
            { _select: '点检人员', editable: true, forceSelection: false, onChange: (v) => this.handlerChange(v), cdt: () => 父级名称 },
            { _radio: '设备照片是否必填' },
            { _int: '排序', textAlign: 'left' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, bReadOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={600}
            controls={
                bReadOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
                    [
                        { _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
                        { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
                        { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default InstrumentCatalogDiv